const EXTRA_LIGHT_FONT_WEIGHT = 100;
export const fixLightFontWeight = (fontWeight) => fontWeight + EXTRA_LIGHT_FONT_WEIGHT;
